import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Attachment, AttachmentApiResponse } from '../models/attachment.model';
import { NavigationContextService } from '../../core/services/navigation-context.service';

@Injectable({
  providedIn: 'root'
})
export class AttachmentRegistryService {
  private http = inject(HttpClient);
  private navContext = inject(NavigationContextService);
  private apiUrl = `${environment.backofficeApiUrl}/api/v1/attachments`;

  /**
   * Ottiene la lista degli allegati - con filtri automatici dal contesto
   * @param domainType Override opzionale del domainType (se non specificato usa il contesto)
   */
  getAttachments(domainType?: string): Observable<AttachmentApiResponse> {
    const context = this.navContext.getCurrentContext();
    
    let params = new HttpParams()
      .set('domainType', domainType || context.domainType);
    
    console.log('[AttachmentService] Loading attachments with context:', { domainType: domainType || context.domainType });
    return this.http.get<AttachmentApiResponse>(this.apiUrl, { params });
  }

  /**
   * Ottiene un allegato specifico per ID
   * @param id ID dell'allegato
   */
  getAttachment(id: number): Observable<AttachmentApiResponse> {
    return this.http.get<AttachmentApiResponse>(`${this.apiUrl}/${id}`);
  }

  /**
   * Estrae l'array di allegati dalla risposta API
   * Gestisce sia array diretti che risposte paginate
   */
  extractAttachmentsArray(response: AttachmentApiResponse): Attachment[] {
    if (!response?.data) return [];
    
    if (Array.isArray(response.data)) {
      return response.data;
    } else if ('content' in response.data) {
      // Risposta paginata
      return Array.isArray((response.data as any).content) 
        ? (response.data as any).content 
        : [(response.data as any).content];
    } else {
      return [response.data];
    }
  }
}
